import Sidebar from "@/components/Sidebar";
import BottomNav from "@/components/BottomNav";

export default function Layout({ children, right = null, wide = false }) {
  return (
    <div className="min-h-screen bg-[#050505] text-[#F4F4F5]">
      <Sidebar />
      <main className="md:pl-[240px] lg:pl-[260px] pb-20 md:pb-0">
        <div
          className={`${
            wide ? "max-w-[1400px]" : "max-w-[1200px]"
          } mx-auto flex ${right ? "gap-0" : ""}`}
        >
          <div className="flex-1 min-w-0 border-x border-[#27272A] min-h-screen">
            {children}
          </div>
          {right ? (
            <aside className="hidden xl:block w-[340px] shrink-0 border-r border-[#27272A]">
              <div className="sticky top-0 p-5 max-h-screen overflow-auto no-scrollbar">
                {right}
              </div>
            </aside>
          ) : null}
        </div>
      </main>
      <BottomNav />
    </div>
  );
}
